module.exports = (__webpack_require__(6))(242);


//////////////////
// WEBPACK FOOTER
// delegated ./src/main/webapp/app/vendor.ts from dll-reference vendor
// module id = 452
// module chunks = 0